import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsToggle',
  setup(__props) {

const store = useStore();
const toggleAds = () => store.commit('toggleAds');
const isDev = computed(() => ['localhost:3000', 'localwww.nslookup.io', 'stgwww.nslookup.io'].includes(window.location.host));

return (_ctx: any,_cache: any) => {
  return (_unref(isDev))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: toggleAds,
        class: "fixed cursor-pointer left-0 bottom-0 p-2 bg-white/50"
      }, "Toggle ads"))
    : _createCommentVNode("", true)
}
}

})